import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { adminApi, apiErrorDetail } from "../../lib/adminApi";

export const AdminLogin = ({ onLogin }) => {
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            await adminApi.post("/admin/login", { password });
            onLogin();
        } catch (err) {
            setError(apiErrorDetail(err, "Anmeldung fehlgeschlagen."));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F4F1EA] flex items-center justify-center px-5">
            <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-[#FAF8F5] border border-[#DDD6C8] p-10">
                <p className="font-sans text-[11px] font-medium tracking-[0.25em] uppercase text-[#8C8275] mb-4 flex items-center gap-2">
                    <Lock size={12} /> Geschützter Bereich
                </p>
                <h1 className="font-serif font-light text-3xl text-[#2B2825]">Anfragen</h1>
                <label htmlFor="admin-password" className="block mt-8 font-sans text-[11px] font-medium tracking-[0.2em] uppercase text-[#8C8275] mb-1">
                    Passwort
                </label>
                <input
                    id="admin-password"
                    data-testid="admin-password-input"
                    type="password"
                    autoFocus
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-transparent border-0 border-b border-[#C8C0B0] focus:border-[#2B2825] rounded-none px-0 py-3 font-sans text-base text-[#2B2825] focus:outline-none focus:ring-0"
                />
                {error && <p data-testid="admin-login-error" className="mt-4 font-sans text-sm text-[#A0522D]">{error}</p>}
                <button
                    data-testid="admin-login-submit"
                    type="submit"
                    disabled={busy}
                    className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-[#2B2825] text-[#FAF8F5] font-sans text-[12px] font-medium tracking-[0.15em] uppercase px-6 py-4 hover:bg-[#4A453F] disabled:opacity-60 transition-colors"
                >
                    {busy && <Loader2 size={15} className="animate-spin" />} Anmelden
                </button>
                <Link to="/" data-testid="admin-back-link" className="mt-6 inline-flex items-center gap-1.5 font-sans text-xs text-[#8C8275] hover:text-[#2B2825]">
                    <ArrowLeft size={12} /> Zur Website
                </Link>
            </form>
        </div>
    );
};
